import { useEffect } from 'react';

import { useInitMarginAccount } from 'src/lib/margin/hooks/account/useInitMarginAccount';

import { SWITCH_PLATFORM_DURATION, useLayoutStore } from './useLayoutStore';

const useLoadingPlatform = () => {
  const { setSwitchPlatform } = useLayoutStore();

  useInitMarginAccount();

  useEffect(() => {
    window.setTimeout(() => {
      setSwitchPlatform(undefined);
    }, SWITCH_PLATFORM_DURATION);
  }, [setSwitchPlatform]);
};

export { useLoadingPlatform };
